import { Stack } from "@mui/material"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { SegmentPickerField } from "src/components/SegmentPickerField"
import { KnowledgeItemStore } from "src/modals/knowledge-items/store"
import { useStore } from "src/store/lib/useStore"

export const KnowledgeItemsPublishSettingsSection = observer(() => {
    const store = useStore(KnowledgeItemStore)

    const setPublishedSegments = useCallback(
        (segments: number[]) => store.formFields.set("segments", segments),
        [store.formFields],
    )

    const handlePublishGroupChange = useCallback(
        (publishGroupIds: number[]) => {
            store.formFields.set("dimension_ids", publishGroupIds)
        },
        [store.formFields],
    )

    const isDisabled =
        store.formFields.get("access_type") === "READ" ||
        store.formFields.get("access_group_id") == null

    return (
        <Stack spacing={2}>
            <SegmentPickerField
                value={store.formFields.get("segments") ?? []}
                accessGroupId={store.formFields.get("access_group_id")}
                onChange={setPublishedSegments}
                disabled={isDisabled}
                dimensionIds={store.formFields.get("dimension_ids")}
                onPublishGroupChange={handlePublishGroupChange}
            />
        </Stack>
    )
})
